module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_ko-3cc279fd88aa35bd07ec50131d0fa9b9.jpg";